// Core lib dependencies.
import React from 'react';

// Shared utils for Display Items.
import * as utils from './utils.jsx';

import { ItemCTA } from './items/item-components';
import ConfigContext from '../../context/ConfigContext.jsx';

/**
 * <pre>
 * Display Item > Document related React components.
 *
 * </pre>
 *
 * @author Various
 * @namespace Common.Components.DisplayItems.Document
 */

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
/* Components */

/**
 * Header.
 *
 * @namespace
 * @memberOf Common.Components.DisplayItems.Document
 */
class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const item = this.props.item;

    return (
      <ConfigContext.Consumer>
        {(config) => {
          const assetUrl = config.assetUrl || this.props.assetUrl;
          const assetUgcUrl = config.assetUgcUrl || this.props.assetUgcUrl;
          const itemAsset = utils.getItemAsset({ item, assetUrl, assetUgcUrl });
          const mainContent = utils.getItemContent({ item, type: 'main' });

          return (
            <div
              onClick={this.props.onClick}
              className={utils.getClassNamesForItem({ item, templateOpts: { itemTemplate: 'header' } })}
            >
              <div className="xItemInner">
                {itemAsset}
                <If condition={!!mainContent}>
                  <div className="xBodyContainer">
                    {mainContent}
                    {this.props.children}
                    {/*  cta content belongs inside body container */}
                    <If condition={!!item.content.link && !!item.content.linkText}>
                      <ItemCTA href={item.content.link} target="_blank" linkText={item.content.linkText} />
                    </If>
                  </div>
                </If>
              </div>
            </div>
          );
        }}
      </ConfigContext.Consumer>
    );
  }
}

export { Header };

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
/* Private utility functions */
